import React from 'react';
import cn from 'classnames';

import './PayOffTheLoan.scss';

interface IPayOffTheLoan {
    className?: string;
}

const PayOffTheLoan: React.FC<IPayOffTheLoan> = ({ className }) => (
    <a
        className={cn('pay_off_the_loan', { className })}
        href='/'
        rel="noopener noreferrer nofollow"
    >Оплатить заём</a>
);

export default PayOffTheLoan;
